import React, { useEffect, Fragment, Suspense, lazy, createElement } from 'react';
const SocialProof = lazy(() => import('./components/SocialProof').then(m => ({
  default: m.SocialProof
})));
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const ProductShowcase = lazy(() => import('./components/ProductShowcase').then(m => ({
  default: m.ProductShowcase
})));
const WhatYouGet = lazy(() => import('./components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Countdown = lazy(() => import('./components/Countdown').then(m => ({
  default: m.Countdown
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const ProBusiness = lazy(() => import('./components/ProBusiness').then(m => ({
  default: m.ProBusiness
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const DarkCTA = lazy(() => import('./components/DarkCTA').then(m => ({
  default: m.DarkCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const PurchaseNotifications = lazy(() => import('./components/PurchaseNotifications').then(m => ({
  default: m.PurchaseNotifications
})));
function deferToIdle(fn: () => void) {
  if ('requestIdleCallback' in window) {
    ;
    (window as any).requestIdleCallback(fn, {
      timeout: 3000
    });
  } else {
    setTimeout(fn, 100);
  }
}
export function App() {
  useEffect(() => {
    document.title = 'MegaPack Terapia Resuelta — Construye Progreso™';
    document.documentElement.lang = 'es';
    const description = 'Sistema completo de intervención clínica para terapeutas en Argentina. 6 Tomos + 6 Bonos con protocolos concretos para casos difíciles, blindaje emocional, manejo de crisis, retención de pacientes y mucho más. Dejá de llevarte el consultorio a casa. Acceso inmediato.';
    const url = 'https://www.construyeprogreso.com';
    const image = 'https://cdn.magicpatterns.com/uploads/1AuUn4dco1P6vxBkxA2G1W/hf_20260420_231501_3cf9079f-b0dd-4c8f-b2b0-8ab6848fec53_(1)-Photoroom.webp';
    // Batch critical meta — single DOM write via fragment
    const frag = document.createDocumentFragment();
    const makeMeta = (attr: string, key: string, content: string) => {
      if (!document.querySelector(`meta[${attr}="${key}"]`)) {
        const el = document.createElement('meta');
        el.setAttribute(attr, key);
        el.content = content;
        frag.appendChild(el);
      }
    };
    makeMeta('name', 'description', description);
    makeMeta('name', 'viewport', 'width=device-width, initial-scale=1');
    makeMeta('name', 'robots', 'index, follow');
    if (frag.childNodes.length) document.head.appendChild(frag);
    deferToIdle(() => {
      const frag2 = document.createDocumentFragment();
      const addMeta = (attr: string, key: string, content: string) => {
        if (!document.querySelector(`meta[${attr}="${key}"]`)) {
          const el = document.createElement('meta');
          el.setAttribute(attr, key);
          el.content = content;
          frag2.appendChild(el);
        }
      };
      addMeta('name', 'keywords', 'terapia resuelta, megapack terapeutas, casos difíciles, burnout terapeuta, protocolo de intervención clínica, retención de pacientes, honorarios terapeutas, blindaje emocional, Argentina, construye progreso');
      addMeta('name', 'author', 'Construye Progreso™');
      if (!document.querySelector('link[rel="canonical"]')) {
        const canonical = document.createElement('link');
        canonical.rel = 'canonical';
        canonical.href = url;
        frag2.appendChild(canonical);
      }
      addMeta('property', 'og:title', 'MegaPack Terapia Resuelta — El sistema para resolver los casos que te quitan el sueño');
      addMeta('property', 'og:description', description);
      addMeta('property', 'og:image', image);
      addMeta('property', 'og:url', url);
      addMeta('property', 'og:type', 'product');
      addMeta('property', 'og:locale', 'es_AR');
      addMeta('property', 'og:site_name', 'Construye Progreso™');
      addMeta('name', 'twitter:card', 'summary_large_image');
      addMeta('name', 'twitter:title', 'MegaPack Terapia Resuelta — Construye Progreso™');
      addMeta('name', 'twitter:description', description);
      addMeta('name', 'twitter:image', image);
      if (frag2.childNodes.length) document.head.appendChild(frag2);
    });
    deferToIdle(() => {
      if (!document.querySelector('script[data-ld="product"]')) {
        const ld = document.createElement('script');
        ld.type = 'application/ld+json';
        ld.setAttribute('data-ld', 'product');
        ld.textContent = JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Product',
          name: 'MegaPack Terapia Resuelta — Sistema de Intervención Clínica™',
          description,
          image,
          brand: {
            '@type': 'Brand',
            name: 'Construye Progreso™'
          },
          offers: {
            '@type': 'AggregateOffer',
            lowPrice: '19990',
            highPrice: '27990',
            priceCurrency: 'ARS',
            availability: 'https://schema.org/InStock',
            offerCount: 2
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '4.9',
            reviewCount: '487'
          }
        });
        document.head.appendChild(ld);
      }
      if (!document.querySelector('script[data-ld="org"]')) {
        const orgLd = document.createElement('script');
        orgLd.type = 'application/ld+json';
        orgLd.setAttribute('data-ld', 'org');
        orgLd.textContent = JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Construye Progreso™',
          url,
          logo: image,
          email: 'construyeprogresoo@gmail.com',
          sameAs: ['https://www.instagram.com/construyeprogresoo']
        });
        document.head.appendChild(orgLd);
      }
      if (!document.querySelector('script[data-ld="faq"]')) {
        const faqLd = document.createElement('script');
        faqLd.type = 'application/ld+json';
        faqLd.setAttribute('data-ld', 'faq');
        faqLd.textContent = JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: [{
            '@type': 'Question',
            name: '¿Qué incluye el MegaPack Terapia Resuelta?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '6 Tomos completos del Método del Caso Difícil + 6 Bonos profesionales: el consultorio rentable, blindaje legal y ético, IA para terapeutas, red de derivación efectiva, kit anti-ghosting y cuaderno de bitácora clínica. Más de 540 páginas de sistema listo para usar.'
            }
          }, {
            '@type': 'Question',
            name: '¿Para qué tipo de terapeuta es este producto?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Para terapeutas holísticos, counselors y acompañantes terapéuticos en Argentina que trabajan con casos difíciles, que sienten que los pacientes no avanzan, que se llevan el consultorio a casa y que quieren un sistema concreto para intervenir con más claridad y menos desgaste.'
            }
          }, {
            '@type': 'Question',
            name: '¿Cómo recibo el material?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Todo es 100% digital en formato PDF. Recibís acceso inmediato en tu email dentro de los 5 minutos posteriores a la compra.'
            }
          }, {
            '@type': 'Question',
            name: '¿Tiene garantía?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Sí, ofrecemos garantía de 7 días sin preguntas. Si no te sirve, te devolvemos el 100% de tu dinero.'
            }
          }]
        });
        document.head.appendChild(faqLd);
      }
    });
  }, []);
  useEffect(() => {
    const loadFbPixel = () => {
      if (typeof window !== 'undefined' && !(window as any).fbq) {
        const f = window as any;
        const n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        (window as any).fbq('init', '1215304437119773');
        (window as any).fbq('track', 'PageView');
        const t = document.createElement('script');
        t.async = true;
        t.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const s = document.getElementsByTagName('script')[0];
        s?.parentNode?.insertBefore(t, s);
      }
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadFbPixel, {
        timeout: 8000
      });
    } else {
      setTimeout(loadFbPixel, 8000);
    }
  }, []);
  return <div className="w-full" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1215304437119773&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>

      <header className="relative flex w-full flex-col items-center justify-center text-center text-gray-900 text-base leading-6 px-5 sm:px-6 lg:px-8 py-12 sm:py-16" role="banner" style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      backgroundImage: 'linear-gradient(135deg, rgb(245,243,255) 0%, rgb(237,233,254) 30%, rgb(245,243,255) 60%, rgb(248,250,252) 100%)',
      backgroundColor: 'rgb(255, 255, 255)'
    }} data-id="element-3">
        {/* Badge */}
        <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-violet-500/30 bg-white/80 px-4 py-1.5 shadow-sm" data-id="element-4">
          <span className="text-xs sm:text-sm font-bold text-violet-700 tracking-wide uppercase" data-id="element-5">
            🧠 Sistema de Intervención Clínica · Terapeutas en Argentina
          </span>
        </div>

        {/* H1 */}
        <h1 className="sm:text-5xl md:text-[64px] lg:text-[72px] sm:leading-tight md:leading-[72px] lg:leading-[80px] font-black max-w-4xl text-gray-900 m-0 mb-2 text-[28px] leading-[36px]" data-id="element-6">
          <span className="block" data-id="element-7">Dejá de improvisar</span>
          <span className="block" data-id="element-8">tus sesiones.</span>
          <span className="block text-violet-700" data-id="element-9">Empezá a ejercer.</span>
        </h1>

        {/* Mockup */}
        <div className="my-6 sm:my-8 w-full max-w-[320px] sm:max-w-[420px] lg:max-w-[480px] aspect-square relative" data-id="element-10">
          <img src="https://cdn.magicpatterns.com/uploads/cFzNNdWPCtUXaqVAzPY6jL/hf_20260421_185515_208515f9-39ff-4336-87a5-56bb3da67672-Photoroom.webp" alt="MegaPack Terapia Resuelta — 6 Tomos + 6 Bonos" width="400" height="400" fetchPriority="high" className="block max-w-full w-full h-auto object-contain relative z-10" style={{
          transform: 'rotateY(-4deg) rotateX(3deg)',
          filter: 'drop-shadow(0 16px 24px rgba(88, 28, 135, 0.25))'
        }} data-id="element-11" />
        </div>

        {/* Identidad profesional — P1 sin cambios */}
        <p className="max-w-xl text-base sm:text-lg font-semibold text-gray-700 leading-7 m-0 mb-4" data-id="element-12">
          El sistema que los terapeutas más sólidos de Argentina usan para
          intervenir con claridad en casos difíciles, sostenerse emocionalmente
          y{' '}
          <span className="text-gray-900 font-black" data-id="element-13">
            dejar de llevarse el consultorio a casa.
          </span>
        </p>

        {/* Tagline — P2 */}
        <p className="max-w-xl text-lg sm:text-xl font-black text-violet-700 m-0 mb-6" data-id="element-14">
          "6 tomos. 6 bonos. Casos resueltos.
          <br className="hidden sm:block" data-id="element-15" />
          Sin improvisar más, sin quemarte más."
        </p>

        {/* Tags */}
        <div className="mb-7 flex max-w-lg flex-wrap items-center justify-center gap-2" data-id="element-16">
          {['📄 100% PDF', '⚡ Acceso Inmediato', '🇦🇷 Argentina', '🧠 Clínica Concreta', '✅ Protocolos Word-for-Word', '🛡️ Blindaje Emocional'].map(tag => <span key={tag} className="whitespace-nowrap bg-white/80 text-xs sm:text-sm font-semibold text-gray-900 leading-5 border border-violet-500/30 rounded-full px-3 py-1 shadow-sm" data-id="element-17">
              {tag}
            </span>)}
        </div>

        {/* CTA */}
        <a href="#pricing" onClick={() => {
        if (typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'Lead', {
            content_name: 'Hero CTA Click',
            content_category: 'Terapia Resuelta'
          });
        }
      }} className="block w-full max-w-sm lg:max-w-md bg-violet-700 text-white text-lg sm:text-xl font-black rounded-xl px-6 sm:px-8 py-4 mb-4 no-underline text-center shadow-lg hover:opacity-90 transition-opacity" data-id="element-18">
          🧠 → QUIERO MI MEGAPACK AHORA
        </a>

        {/* Trust Badges */}
        <div className="flex flex-row flex-wrap items-center justify-center gap-3 sm:gap-4 m-0" data-id="element-19">
          <span className="inline-flex items-center gap-1.5 bg-white/80 border border-gray-200 rounded-full px-3 py-1.5 text-xs sm:text-sm text-gray-600 shadow-sm" data-id="element-20">
            🛡️ Garantía 7 días
          </span>
          <span className="inline-flex items-center gap-1.5 bg-white/80 border border-gray-200 rounded-full px-3 py-1.5 text-xs sm:text-sm text-gray-600 shadow-sm" data-id="element-21">
            🔒 Pago seguro
          </span>
          <span className="inline-flex items-center gap-1.5 bg-white/80 border border-gray-200 rounded-full px-3 py-1.5 text-xs sm:text-sm text-gray-600 shadow-sm" data-id="element-22">
            💳 Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>
      </header>

      <main role="main" aria-label="Contenido principal" data-id="element-23">
        <Suspense fallback={null} data-id="element-24">
          <SocialProof data-id="element-25" />
          <PainPoints data-id="element-26" />
        </Suspense>

        <div className="cv-auto" data-id="element-27">
          <Suspense fallback={null} data-id="element-28">
            <ProductShowcase data-id="element-29" />
          </Suspense>
        </div>

        <div className="cv-auto" data-id="element-30">
          <Suspense fallback={null} data-id="element-31">
            <WhatYouGet data-id="element-32" />
            <Bonuses data-id="element-33" />
            <Countdown data-id="element-34" />
            <Pricing data-id="element-35" />
          </Suspense>
        </div>

        <div className="cv-auto" data-id="element-36">
          <Suspense fallback={null} data-id="element-37">
            <ProBusiness data-id="element-38" />
            <Guarantee data-id="element-39" />
            <Testimonials data-id="element-40" />
            <FAQ data-id="element-41" />
            <DarkCTA data-id="element-42" />
          </Suspense>
        </div>
      </main>

      <div className="cv-auto" data-id="element-43">
        <Suspense fallback={null} data-id="element-44">
          <Footer data-id="element-45" />
          <PurchaseNotifications data-id="element-46" />
        </Suspense>
      </div>
    </div>;
}